/**
 * MarketingModeBar — top tier of the two-tier nav.
 *
 * Sticky 52px top header. 5 workspace mode buttons (Plan / Create /
 * Distribute / Measure / Agents) + Cmd+K command bar trigger + avatar.
 * Emblem + wordmark intentionally omitted per user request.
 *
 * Mode source-of-truth lives in lib/marketingIA.js.
 */
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/App";
import { useCommandBar } from "@/components/marketing/CommandBar";
import CommandBar from "@/components/marketing/CommandBar";
import { Compass, PenSquare, Share2, BarChart2, Bot, Command, Sparkles } from "lucide-react";
import { MARKETING_IA, MODE_ORDER, getModeForPath } from "@/lib/marketingIA";

const MODE_ICON = { plan: Compass, create: PenSquare, distribute: Share2, measure: BarChart2, agents: Bot };

export { getModeForPath };

export default function MarketingModeBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const cmdK = useCommandBar();

  const activeMode = getModeForPath(location.pathname);
  const initials = (user?.full_name || user?.email || "?")
    .split(/\s+/).map((s) => s[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();

  return (
    <>
      <div className="mh-modebar" data-testid="marketing-modebar">
        <div className="mh-modebar-inner">
          <div className="mh-modes" role="tablist">
            {MODE_ORDER.map((mode) => {
              const Icon = MODE_ICON[mode];
              const active = activeMode === mode;
              return (
                <button
                  key={mode}
                  onClick={() => navigate(MARKETING_IA[mode].landing)}
                  className={`mh-mode-btn ${active ? "is-active" : ""}`}
                  role="tab"
                  aria-selected={active}
                  data-testid={`mode-${mode}`}
                >
                  <Icon style={{ width: 14, height: 14 }} />
                  <span>{MARKETING_IA[mode].label}</span>
                </button>
              );
            })}
          </div>
          <div style={{ flex: 1 }} />
          <button className="mh-cmdk" onClick={() => cmdK.setOpen(true)} data-testid="modebar-cmdk">
            <Sparkles style={{ width: 13, height: 13, color: "var(--mh-muted)" }} />
            <span>Ask anything…</span>
            <span className="mh-kbd"><Command style={{ width: 9, height: 9, display: "inline" }} />K</span>
          </button>
          <div className="mh-avatar" title={user?.full_name || user?.email}>{initials || "?"}</div>
        </div>
      </div>
      <CommandBar open={cmdK.open} onClose={() => cmdK.setOpen(false)} />
    </>
  );
}
